/**
 * CombatMoodDriver tunables — how ability-cast "heat" pulses the scene
 * atmosphere. The driver accumulates heat per cast (capped at 1), bleeds it off
 * over time, and maps heat → a scene-mood multiplier the AtmosphereLayer applies
 * on top of the per-level base mood. Reusable across every mood-reactive map.
 */
export interface CombatMoodConfig {
  /** Master switch (off → driver never starts, mood stays flat). */
  enabled: boolean;
  /** Heat added per ability cast — accumulator is 0..1, capped at 1. */
  bumpPerCast: number;
  /** Heat bled off per second (full cooldown ≈ 1 / decayPerSec seconds). */
  decayPerSec: number;
  /** Scene-mood multiplier at FULL heat. 1 = no change; >1 intensifies the
   *  ambient lights/density during combat. */
  peak: number;
}

export const COMBAT_MOOD: CombatMoodConfig = {
  enabled: true,
  bumpPerCast: 0.28, // ~4 casts to peak; sustained fighting holds it high
  decayPerSec: 0.5, // full heat → calm in ~2s of no casting
  peak: 1.6,
};
